import React from 'react';
import { Outlet } from 'react-router-dom';
import PrivacyContainer from '../../../containers/Privacy/Privacy';

const Privacy: React.FC = () => {
  return (
    <PrivacyContainer>
      <Outlet />
    </PrivacyContainer>
  );
};

export default Privacy;
